import React from 'react';
import { Field, Modal, Spinner } from '../../components/ui';
import { GUEST_TYPES } from './useCards';

// Mobile Cards — the same list of card names, one per row, tap to edit the text.
export default function CardsMobile({ vm }) {
  const {
    canView, canEdit, cards, counts, loading, functions, fnFilter, setFnFilter,
    typeFilter, setTypeFilter, q, setQ, editing, setEditing, cardForm, setCardF, saveCard, saving,
    openCard, print,
  } = vm;

  if (!canView) {
    return (
      <div>
        <div className="page-head"><h1>Cards</h1></div>
        <div className="card card-pad empty">You do not have access to the guest list of this event.</div>
      </div>
    );
  }

  return (
    <div>
      <div className="mobile-toolbar guest-controls-sticky">
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <strong style={{ fontSize: 16 }}>Cards</strong>
          <span className="muted" style={{ fontSize: 12 }}>{counts.cards}</span>
          <div style={{ flex: 1 }} />
          <button className="btn light sm" onClick={print}>🖨 Print</button>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <select value={fnFilter} onChange={e => setFnFilter(e.target.value)} aria-label="Function"
            style={{ padding: '10px 12px', border: '1px solid var(--line)', borderRadius: 10 }}>
            <option value="">All functions</option>
            {functions.map(f => <option key={f.FunctionId} value={f.FunctionId}>{f.FunctionName}</option>)}
          </select>
          <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} aria-label="Type"
            style={{ padding: '10px 12px', border: '1px solid var(--line)', borderRadius: 10 }}>
            <option value="">All types</option>
            {GUEST_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <input placeholder="Search…" value={q} onChange={e => setQ(e.target.value)}
          style={{ padding: '10px 12px', border: '1px solid var(--line)', borderRadius: 10 }} />
      </div>

      <div className="card guest-stats-compact">
        <strong>{counts.cards}</strong> cards | <strong>{counts.family}</strong> families | <strong>{counts.business}</strong> business
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div>
        : cards.length === 0 ? <div className="card card-pad empty">No guests match.</div> : (
          <div className="mobile-card-list card-sheet">
            {cards.map((c, i) => (
              <div key={c.key} className="card card-pad mobile-record-card guest-card" onClick={() => canEdit && openCard(c)}>
                <div className="mobile-card-head">
                  <div style={{ minWidth: 0 }}>
                    <strong className="mobile-title guest-card-name">{i + 1}. {c.name}</strong>
                    {c.subtitle && <div className="muted guest-card-sub" style={{ fontSize: 12 }}>{c.subtitle}</div>}
                  </div>
                  <div style={{ flex: 1 }} />
                  <span className={c.type === 'Business' ? 'chip male' : 'chip pend'}>{c.type}</span>
                </div>
                <div className="mobile-meta guest-card-meta">
                  <div>{c.mobile || '—'}{c.city ? ` · ${c.city}` : ''}{c.persons > 1 ? ` · ${c.persons} persons` : ''}</div>
                  {c.functions.length > 0 && <div className="muted guest-card-fns">{c.functions.join(' · ')}</div>}
                </div>
              </div>
            ))}
          </div>
        )}

      {editing && (
        <Modal
          fullScreen
          title={`Card · ${editing.name}`}
          onClose={() => setEditing(null)}
          footer={<>
            <button className="btn light" onClick={() => setEditing(null)}>Cancel</button>
            <button className="btn primary" style={{ flex: 1, padding: 12 }} disabled={saving} onClick={saveCard}>
              {saving ? 'Saving…' : 'Save'}
            </button>
          </>}
        >
          <div className="step-label">Card type</div>
          <div className="chips-row" style={{ marginBottom: 12 }}>
            {GUEST_TYPES.map(t => (
              <button key={t} type="button" className={'chip-toggle' + (cardForm.GuestType === t ? ' on' : '')}
                onClick={() => setCardF('GuestType', t)}>{t}</button>
            ))}
          </div>
          {cardForm.GuestType === 'Business' && (
            <Field label="Company name" value={cardForm.CompanyName} onChange={(v) => setCardF('CompanyName', v)} />
          )}
          <Field label="Name on the card" value={cardForm.CardName} onChange={(v) => setCardF('CardName', v)}
            placeholder="Leave blank to use the guest's name" />
          <div className="muted" style={{ fontSize: 12 }}>
            One card per household — this applies to every member of the family.
          </div>
        </Modal>
      )}
    </div>
  );
}
